/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import { IIconStyles } from "office-ui-fabric-react/lib/Icon";
import { ITextFieldStyles, ITextFieldStyleProps } from "office-ui-fabric-react/lib/TextField";
import { IStyleFunctionOrObject } from "office-ui-fabric-react/lib/Utilities";
import styled from "styled-components";

import { desktopInputFontSize, desktopInputHeight } from "../ReactHookFormShared.styles";

/**
 * Styling for text field control.
 * @type {IStyleFunctionOrObject<ITextFieldStyleProps, ITextFieldStyles>}
 */
export const textFieldStyles: IStyleFunctionOrObject<ITextFieldStyleProps, ITextFieldStyles> = {
  field: {
    height: desktopInputHeight,
    lineHeight: "1.75rem",
    padding: "10px 12px",
    fontSize: desktopInputFontSize,
    selectors: {
      ["::placeholder"]: {
        fontSize: desktopInputFontSize,
      },
    },
  },
  fieldGroup: {
    minHeight: desktopInputHeight,
  },
  prefix: {
    fontSize: desktopInputFontSize,
  },
  root: { width: "100%" },
};

/**
 * Styling for ICon control.
 * @type {Partial<IIconStyles>}
 * @param {boolean} hasAsterisk The value to determine if control label has required asterisk.
 */
export const getIconStyles: (hasAsterisk: boolean) => Partial<IIconStyles> = (hasAsterisk) => {
  return { root: { paddingLeft: !hasAsterisk ? "10px" : "", color: "#0078D7" } };
};

/**
 * Styled div for counter and error message.
 */
export const CounterAndErrorMessageDiv = styled.div`
  width: 100%;
  display: flex;
`;
